import { HttpErrorResponse } from '@angular/common/http';
import { Component, input } from '@angular/core';

import { addBusinessDays } from 'date-fns';
import { Observable } from 'rxjs';

import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput } from '@camelot/form-model';
import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent, DepartmentProfessionsComponent, LoaderComponent } from '@camelot/ui';

import { CamTranslationCore } from '../../../../../translation.service';
import { BaseTemplateComponent } from '../base-template';

export enum EFormSnoozeField {
  SnoozeType = 'snoozeType',
  NewDate = 'newDate',
}

export enum ESnoozeDuration {
  SnoozeOneDay,
  SnoozeTwoDays,
  SnoozeFiveDays,
  NewDate,
}

@Component({
  selector: 'cam-snooze-template',
  templateUrl: './snooze-template.component.html',
  styleUrls: ['./snooze-template.component.scss'],
  imports: [DepartmentProfessionsComponent, FormComponent, LoaderComponent, ButtonComponent, TranslatePipe],
})
export class SnoozeTemplateComponent extends BaseTemplateComponent {
  ctaService = input.required<{
    getSnoozeForm: () => CamAbstractInput[];
    snooze: (id: number, data: { date: Date }) => Observable<any>;
  }>();

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  public setForm() {
    this.form.set(this.ctaService().getSnoozeForm());
  }

  public override send(data: any) {
    const snoozeType = Number(data[EFormSnoozeField.SnoozeType]) as ESnoozeDuration;

    let finalDate = new Date(Date.now());

    switch (snoozeType) {
      case ESnoozeDuration.SnoozeOneDay:
        finalDate = addBusinessDays(finalDate, 1);
        break;
      case ESnoozeDuration.SnoozeTwoDays:
        finalDate = addBusinessDays(finalDate, 2);
        break;
      case ESnoozeDuration.SnoozeFiveDays:
        finalDate = addBusinessDays(finalDate, 5);
        break;
      case ESnoozeDuration.NewDate:
        finalDate = new Date(data['newDate']);
        break;
    }
    this.requestState.asked();
    this.ctaService()
      .snooze(this.currentItem.id, {
        date: finalDate,
      })
      .subscribe({
        complete: () => {
          this.next();
          this.requestState.completed();
        },
        error: (error: HttpErrorResponse) => {
          this.requestState.onError(error.status, error.statusText);
        },
      });
  }
}
